import { NotifyHelper } from "../../../helpers/toast";
import { eEmailDefine } from "../../action-types/email/IEmailActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const emailActions = {
    ...generateActions(eEmailDefine, "EMAIL"),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "SAVE_SUCCESS", () => NotifyHelper.Success("Saved!")),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "CHANGE_SELECTED_IDS", (m: any) => { }),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "CHANGE_APPROVE_SELECTED_IDS", (m: any) => { }),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "CHANGE_TRANGTHAI_SELECTED_IDS", (m: any) => { }),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "SHOW_APPROVE_MODAL", (m: any) => { }),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "SHOW_REJECT_MODAL", (m: any) => { }),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "APPROVE_SUCCESS", () => NotifyHelper.Success("Approved!")),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "APPROVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "REJECT_SUCCESS", (m: any) => NotifyHelper.Success("Rejected!")),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "REJECT_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(eEmailDefine, "EMAIL",
        "SHOW_DETAIL_APPROVE_MODAL", (m: any) => { }),
}